/* The cart drawer's behaviour. It lived inline in snippets/cart-drawer.liquid
   until 2026-09-03, 18 KB shipped in the HTML of every page and parsed
   again on each view; here it is fetched once and cached. The four values
   it took from Liquid arrive as window.BTCartDrawerConfig, written by the
   snippet just before this file is requested. Deferred, after theme.js in
   document order, so BTModal and BTFormat exist when it runs. */
(function(){
  var CFG = window.BTCartDrawerConfig || {};
  var FREE_SHIP = Number(CFG.freeShip) || 0;
  // Opt-in, off unless the theme setting is ticked. Written as a plain `if` on
  // the setting rather than the `unless … == false` used by the defaults-on
  // settings above: this one defaults to off, so an absent value should read as
  // off too.
  var QTY_STEPPER = !!CFG.qtyStepper;
  var drawer = document.getElementById('cartDrawer');
  if(!drawer) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  var elItems  = drawer.querySelector('.js--cart-items');
  var elFoot   = drawer.querySelector('.js--cart-foot');
  var elTotal  = drawer.querySelector('.js--cart-drawer-total');
  var elDiscounts = drawer.querySelector('.js--cart-drawer-discounts');
  var elCount  = drawer.querySelector('.js--cart-drawer-count');
  var elShip   = drawer.querySelector('.js--cart-ship');
  var elShipMsg= drawer.querySelector('.js--cart-ship-msg');
  var elShipFill=drawer.querySelector('.js--cart-ship-fill');
  var elError  = drawer.querySelector('.js--cart-error');

  function money(cents){ return window.BTFormat.money(cents); }

  /* The bag's purchase terms, by line: { "<line key>": { f, p } } -- final
     sale and pre-order, from snippets/purchase-terms.liquid by
     way of snippets/cart-terms.liquid: the answers /cart prints. cart.js
     carries no tags or stock rules, so Liquid supplies the map: with the page
     for the lines already in the bag, then from the cart-terms section, which
     BTCart bundles into every add and change. Each map replaces the last
     whole, so a line that was re-keyed or removed leaves nothing behind, and
     stock that changed is read fresh. It was a final-sale map by product
     until 2026-10-03; two sizes of one product can differ on pre-order
     (Codex follow-up review).

     A line the map hasn't seen (added in another tab, or by an app) is
     UNKNOWN, apart from a line with no terms, and is asked about in one
     request for the whole bag. Until an answer lands, the line's own
     properties stand in: _final_sale and _preorder were set from the same
     rules when it was added. An answer that lands after a bundled map is
     dropped, because the bundled one is newer.

     A lookup that fails -- dropped, timed out, not JSON, no section, or a map
     missing a line in the bag -- leaves those lines unknown and is asked
     again on a later bag update or drawer open, after a wait that doubles
     each time, five attempts at most. window.BTCartTermsBackoff and
     BTCartTermsTimeout override the figures, for tests. */
  var TERMS_SECTION = 'cart-terms';
  var TERMS_TRIES = 5;
  var terms = CFG.terms || {};
  var termsVersion = 0;
  var termsLookup = { pending: false, failures: 0, retryAt: 0 };
  if(window.BTCart && window.BTCart.register) window.BTCart.register(TERMS_SECTION);

  function readTerms(html){
    if(!html) return null;
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var el = tpl.content.querySelector('[data-cart-terms]');
    if(!el) return null;
    try {
      var map = JSON.parse(el.textContent);
      if(!map || typeof map !== 'object' || Array.isArray(map)) return null;
      // Only {f, p} entries of 0 or 1 count. Anything else is left out, so
      // its line reads as unknown and is asked about, rather than as a line
      // with no terms (Codex, follow-up review 2).
      var clean = {};
      Object.keys(map).forEach(function(k){
        var t = map[k];
        if(t && (t.f === 0 || t.f === 1) && (t.p === 0 || t.p === 1)) clean[k] = t;
      });
      return clean;
    } catch(e){ return null; }
  }

  function takeTerms(map){
    terms = map;
    termsVersion++;
  }

  function lineTerms(item){
    var t = terms[item.key];
    if(t) return { final: !!t.f, preorder: !!t.p };
    var props = item.properties || {};
    return {
      final: !!props._final_sale,
      preorder: String(props._preorder == null ? '' : props._preorder).trim() !== ''
    };
  }

  function unclassified(cart){
    return !!cart && cart.items.some(function(i){ return !terms[i.key]; });
  }

  function lookupSettled(cart){
    if(unclassified(cart)) return false;
    termsLookup.failures = 0;
    termsLookup.retryAt = 0;
    return true;
  }

  function lookupFailed(){
    termsLookup.failures++;
    termsLookup.retryAt = Date.now() + (window.BTCartTermsBackoff || 2000) * Math.pow(2, termsLookup.failures - 1);
  }

  function classifyNew(cart){
    if(!unclassified(cart) || termsLookup.pending) return;
    if(termsLookup.failures >= TERMS_TRIES || Date.now() < termsLookup.retryAt) return;
    termsLookup.pending = true;
    var since = termsVersion;
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function(){ if(ctrl) ctrl.abort(); }, window.BTCartTermsTimeout || 10000);
    fetch(root + '?sections=' + TERMS_SECTION, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        var map = data && readTerms(data[TERMS_SECTION]);
        if(map && termsVersion === since){
          takeTerms(map);
          if(lastCart) render(lastCart);
        }
        if(!map || !lookupSettled(lastCart)) lookupFailed();
      })
      .catch(lookupFailed)
      .then(function(){ clearTimeout(timer); termsLookup.pending = false; });
  }

  // Colour and size as separate values instead of the single "Nicole Coral /
  // xs" string.
  //
  // Read out of options_with_values by NAME rather than by position: which
  // option is first is a per-product setting, so indexing would put a size in
  // the colour slot on any product built the other way round. Anything that is
  // neither colour nor size is kept and shown as-is rather than dropped, so a
  // product with a third option doesn't silently lose it.
  //
  // "Default Title" is what a product with no real options reports, and is not
  // something to print. Casing is left alone here and handled in CSS — the
  // stored values are inconsistent ("Nicole Coral" on one product, "pear" on
  // another), so display case belongs with the display.
  function variantParts(item){
    var out = { color: '', size: '', rest: [] };
    var opts = item.options_with_values || [];
    var named = false;
    opts.forEach(function(o){
      var n = String((o && o.name) || '').toLowerCase();
      var v = (o && o.value != null) ? String(o.value) : '';
      if (!v || v.toLowerCase() === 'default title') return;
      if (n === 'color' || n === 'colour') { out.color = v; named = true; }
      else if (n === 'size') { out.size = v; named = true; }
      else out.rest.push({ name: (o && o.name) ? String(o.name) : '', value: v });
    });
    // Older carts, or anything that didn't report options, still get a line.
    if (!named && !out.rest.length && item.variant_title &&
        item.variant_title.toLowerCase() !== 'default title') {
      out.rest = item.variant_title.split(' / ').map(function(v){ return { name: '', value: v }; });
    }
    return out;
  }

  var panel = drawer.querySelector('.cart-drawer__panel') || drawer;

  function openDrawer(){
    if(drawer.classList.contains('is-open')) return;
    // A lookup that failed earlier gets another go when the bag is looked at.
    if(lastCart) classifyNew(lastCart);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-open');
    // No target: focus lands on the panel, and the first Tab from there is
    // the close button, so a keyboard user still meets the way out before
    // the bag. See BTModal.open for why the X is not focused directly.
    if(window.BTModal) window.BTModal.open(panel);
  }
  function closeDrawer(){
    if(!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-open');
    if(window.BTModal) window.BTModal.close();
  }
  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;

  // Ask the CDN for a width rather than rewriting the filename to the legacy
  // _NxN form; this way it can serve WebP and honour the source's own params.
  function imgUrl(src, size){
    if(!src) return '';
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', size);
      return u.toString();
    } catch(e){ return src; }
  }

  // Line items are built as an HTML string, so anything interpolated into it
  // has to be escaped. Product titles are merchant-controlled rather than
  // hostile, but they are not safe: `Meg 54" Cap Sleeve Caftan` is already in
  // this catalogue, and that quote closes an attribute early.
  function esc(str){ return window.BTFormat.esc(str); }

  function showCartError(message){
    if(!elError) return;
    elError.textContent = message;
    elError.hidden = false;
  }
  function clearCartError(){
    if(!elError) return;
    elError.textContent = '';
    elError.hidden = true;
  }

  // The cart as the server last confirmed it. The stepper reads quantities
  // from here; it read them from the DOM through `.cart-item`, a class these
  // rows have never carried, so + always sent 1 and - always sent 0, which
  // removed the line (Codex review, 2026-10-01; dormant while the stepper
  // setting is off).
  var lastCart = null;

  var lastItemsHtml = null;

  function render(cart){
    var prevCart = lastCart;
    lastCart = cart;
    // counters
    document.querySelectorAll('.js--cart-counter').forEach(function(el){
      el.innerText = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    // The header bag shows no number (2026-10-08); its name carries it,
    // "Bag, 2 items". The two plural forms come translated for 1 and 2, and
    // the 2 is swapped for the count.
    var T0 = CFG.t || {};
    document.querySelectorAll('.js--cart-link').forEach(function(el){
      var n = cart.item_count;
      el.setAttribute('aria-label', n === 0 ? (T0.bag || 'Bag')
        : n === 1 ? (T0.bagOne || 'Bag, 1 item')
        : (T0.bagOther || 'Bag, 2 items').replace('2', n));
    });
    // No count beside the title when the bag is empty: "Your bag is empty"
    // below says it (the user, 2026-10-06).
    if(elCount){
      elCount.innerText = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      elCount.hidden = cart.item_count === 0;
    }

    // free shipping message and bar, in three states (a fourth, disabled, is
    // the block not being rendered when the threshold is 0):
    //   empty            states the threshold; no bar
    //   below threshold  the sum still to spend, and the bar
    //   unlocked         the confirmation; no bar
    // render() runs on every change to the bag, so each state clears the others'
    // classes: adding to an empty bag, removing back to empty and crossing the
    // threshold either way all land here.
    if(elShip && FREE_SHIP > 0){
      var remaining = FREE_SHIP - cart.total_price;
      if(cart.item_count === 0){
        var tmpl = (CFG.t && CFG.t.shipThreshold) || '<a href="/pages/shipping">Free shipping</a> on US orders of __A__ or more.';
        elShipMsg.innerHTML = tmpl.replace('__A__', '<strong>' + money(FREE_SHIP) + '</strong>');
        elShipMsg.classList.remove('cart-ship__msg--done');
        elShip.classList.remove('cart-ship--done');
        elShip.classList.add('cart-ship--empty');
        elShipFill.style.width = '0%';
      } else if(remaining <= 0){
        elShipMsg.innerHTML = "Your bag qualifies for <a href=\"/pages/shipping\">free shipping</a> in the US.";
        elShipMsg.classList.add('cart-ship__msg--done');
        // The bar is a measure of what is left to do, so once there is none it
        // has nothing to say: a full pink rule under "you have unlocked free
        // shipping" is decoration repeating the sentence above it. The state
        // goes on the block and CSS hides the track, rather than the bar being
        // removed from the DOM, so it is still there to animate back if a line
        // is deleted and the total drops under the threshold again.
        elShip.classList.remove('cart-ship--empty');
        elShip.classList.add('cart-ship--done');
        elShipFill.style.width = '100%';
      } else {
        elShipMsg.innerHTML = "You're <strong>" + money(remaining) + "</strong> away from <a href=\"/pages/shipping\">free shipping</a> in the US.";
        elShipMsg.classList.remove('cart-ship__msg--done');
        elShip.classList.remove('cart-ship--done');
        elShip.classList.remove('cart-ship--empty');
        elShipFill.style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + '%';
      }
    }

    // empty state
    if(cart.item_count === 0){
      replaceItems(prevCart,
        '<div class="cart-empty">'+
          '<p class="cart-empty__title">'+ (CFG.t && CFG.t.empty || 'Your bag is empty') +'</p>'+
          '<p class="cart-empty__text">Discover hand-beaded caftans and resort-ready pieces made to be lived in.</p>'+
          '<a class="btn btn--neutral" href="'+ root +'collections/all" data-cart-close>'+ esc((CFG.t && CFG.t.startShopping) || 'Start shopping') +'</a>'+
        '</div>');
      if(elFoot) elFoot.hidden = true;
        return;
    }

    // line items
    var html = '';
    cart.items.forEach(function(item){
      var key = esc(item.key);
      var name = esc(item.product_title);
      // Final sale and pre-order, from the terms map above.
      var lt = lineTerms(item);
      var parts = variantParts(item);
      var T = CFG.t || {};
      // The options as one short phrase, the colour then the size: "Ikat
      // green in XS" (the user, 2026-10-03; Codex's labelled "Color:" and
      // "Size:" lines read as a form). The phrase is translated, with the two
      // values put in after it is escaped. A third option, and the count when
      // the stepper is off, take a line of their own.
      function line(html, cls){ return '<div class="drawer-item__opt'+ (cls ? ' '+ cls : '') +'">'+ html +'</div>'; }
      // Colour goes through title(), the house style from 2026-10-08:
      // "Flora Blue", and a value entered lowercase, "pool", reads "Pool".
      var colorHtml = parts.color ? esc(window.BTFormat.title(parts.color)) : '';
      // The size code keeps its case through .opt-size: XS, XXL.
      var sizeHtml = parts.size ? '<span class="opt-size">'+ esc(parts.size) +'</span>' : '';
      var both = (T.colorInSize || '__C__ in __S__');
      // Both placeholders in one pass, through a function: a replacement
      // STRING reads $& and $1 as patterns, so a colour "$& green" came out
      // "__C__amp; green", and a second pass would rescan the first's text.
      var phrase = esc(both).replace(/__C__|__S__/g, function(m){ return m === '__C__' ? colorHtml : sizeHtml; });
      // A pre-order says so in a word after the colour and size, "Ikat green
      // in XS, Pre-order" (the user, 2026-10-03), in place of a line of its
      // own with the ship line. That stays on the line as _preorder, for the
      // order, and the product page and the card show it before the add.
      var preHtml = lt.preorder ? '<span class="opt-preorder">'+ esc(T.preorder || 'Pre-order') +'</span>' : '';
      var first = colorHtml && sizeHtml ? phrase
        : colorHtml ? colorHtml
        : sizeHtml ? esc(T.size || 'Size') +' '+ sizeHtml : '';
      if(preHtml) first = first ? first +', '+ preHtml : preHtml;
      var opts =
        (first ? line(first) : '')+
        parts.rest.map(function(r){ return line((r.name ? esc(r.name) +' ' : '') + esc(r.value)); }).join('');
      // With the stepper off, the count shows from two, where the line
      // total would otherwise be unexplained; at one it says nothing the
      // line doesn't. With the stepper on, the stepper is the count.
      // "Qty: 2" on screen (the user, 2026-10-08) and "Quantity 2" to a
      // screen reader, which spells an abbreviation out letter by letter.
      // It sits where the stepper would, beside Remove (layout A, 2026-10-08).
      var qtyText = !QTY_STEPPER && item.quantity > 1 ? line(
        '<span aria-hidden="true">'+ esc(T.quantityShort || 'Qty: __N__').replace('__N__', item.quantity) +'</span>'+
        '<span class="visually-hidden">'+ esc(T.quantity || 'Quantity') +' '+ item.quantity +'</span>', 'cart-item__qty') : '';
      html +=
        '<div class="drawer-item prow" data-key="'+ key +'">'+
          // 88x122 is the drawer's .prow__media box: 88px wide at 18/25 (72
          // on a phone, the same shape; the user asked for a taller photo,
          // 2026-10-03). Theme check cannot see an img built in a JS string,
          // so these have to be kept right by hand. Under object-fit: contain
          // they are the BOX, not the picture. 176 is that box at 2x. A line
          // with no image keeps the empty box.
          '<div class="prow__media">'+ (item.image
            ? '<a href="'+ esc(item.url) +'"><img src="'+ esc(imgUrl(item.image, 176)) +'" alt="'+ name +'" width="88" height="122" loading="lazy" decoding="async"></a>'
            : '') +'</div>'+
          '<div class="prow__body">'+
            '<div class="prow__name">'+ name +'</div>'+
            (opts ? '<div class="drawer-item__opts">'+ opts +'</div>' : '')+
            (lt.final ? '<div class="cart-item__preorder cart-item__final-sale">'+ esc(T.finalSale || 'Final sale') +'</div>' : '')+
            // Laid out by THE BAG DRAWER'S LINE (theme.css): the price beside
            // the name, the quantity (text or stepper) and Remove on the last
            // row. final_line_price is the line, net of any automatic
            // discount, which is named under it.
            '<div class="cart-item__foot">'+
              '<div class="drawer-item__price">'+
                '<span class="prow__price">'+ money(item.final_line_price) +'</span>'+
                ((item.line_level_discount_allocations || []).length
                  ? '<span class="prow__discount">'+ item.line_level_discount_allocations.map(function(d){ return esc(d.discount_application.title) + ' \u2212' + money(d.amount); }).join(', ') +'</span>'
                  : '')+
              '</div>'+
              '<div class="cart-item__qtyrow'+ (QTY_STEPPER ? ' cart-item__qtyrow--stepper' : '') +'">'+
                // The stepper always shows when it is switched on -- it is the
                // control, and hiding it at one would strip the only way up
                // from a single unit.
                (QTY_STEPPER
                  ? '<div class="qty">'+
                      '<button type="button" aria-label="Decrease quantity of '+ name +'" data-qty-dec data-key="'+ key +'">&ndash;</button>'+
                      '<span class="qty__val">'+ shownQty(item) +'</span>'+
                      '<button type="button" aria-label="Increase quantity of '+ name +'" data-qty-inc data-key="'+ key +'">+</button>'+
                    '</div>'
                  : qtyText)+
                '<button class="cart-item__remove" type="button" aria-label="Remove '+ name +' from bag" data-qty-remove data-key="'+ key +'">Remove</button>'+
              '</div>'+
            '</div>'+
          '</div>'+
        '</div>';
    });
    replaceItems(prevCart, html);

    // totals, with any discount on the whole bag named above them
    if(elDiscounts){
      var cartDiscounts = cart.cart_level_discount_applications || [];
      // Two shapes reach here: /cart.js gives {title, total_allocated_amount},
      // and /cart/change.js gives {discount_application: {title}, amount}
      // (Codex, REVIEW-2 of the full-theme fixes: the second rendered a blank
      // title and NaN).
      elDiscounts.innerHTML = cartDiscounts.map(function(d){
        var title = d.title != null ? d.title : (d.discount_application && d.discount_application.title) || '';
        var amount = d.total_allocated_amount != null ? d.total_allocated_amount : d.amount;
        return '<div class="cart-foot__row cart-foot__row--discount"><span>'+ esc(title) +'</span><span>\u2212'+ money(amount || 0) +'</span></div>';
      }).join('');
      elDiscounts.hidden = !cartDiscounts.length;
    }
    if(elTotal) elTotal.innerText = money(cart.total_price);
    if(elFoot) elFoot.hidden = false;
  }

  /*
    The rows are replaced only when their markup changes, and focus comes
    back when they are. A keyboard shopper on + used to lose focus to the
    page on every answer, and twice per click once the target settled
    (Codex, third pass). Focus is recorded as a role (+, -, Remove) on a line
    IDENTITY, read through the cart the rows were drawn from, and returned to
    the same control on the same line, re-keyed or not; to the nearest line
    if that one went; to the empty bag's link if the bag emptied.
  */
  var ROLES = { inc: '[data-qty-inc]', dec: '[data-qty-dec]', remove: '[data-qty-remove]' };

  function replaceItems(prevCart, html){
    // Same markup: nothing to replace, but a click writes its target straight
    // into the row, so the numbers shown are brought back to what the markup
    // says -- the confirmed quantity, or a target still on its way. Skipping
    // this left a refused + showing 2 beside a bag of 1.
    if(html === lastItemsHtml){
      Array.prototype.forEach.call(elItems.querySelectorAll('.drawer-item'), function(row){
        var line = lineFor(row.dataset.key);
        var val = row.querySelector('.qty__val');
        if(line && val && val.textContent !== String(shownQty(line))) val.textContent = shownQty(line);
      });
      return;
    }
    var focus = null;
    var active = document.activeElement;
    if(active && elItems.contains(active)){
      var role = null;
      for(var r in ROLES){ if(active.matches(ROLES[r])) role = r; }
      var prevLine = prevCart && prevCart.items.filter(function(i){ return i.key === active.dataset.key; })[0];
      var rows = Array.prototype.slice.call(elItems.querySelectorAll('.drawer-item'));
      focus = { role: role, id: prevLine ? window.BTCart.identity(prevLine) : null,
                index: rows.indexOf(active.closest('.drawer-item')) };
    }
    elItems.innerHTML = html;
    lastItemsHtml = html;
    elItems.querySelectorAll('[data-qty-inc]').forEach(function(b){ b.addEventListener('click', function(){ changeQty(b.dataset.key, +1); }); });
    elItems.querySelectorAll('[data-qty-dec]').forEach(function(b){ b.addEventListener('click', function(){ changeQty(b.dataset.key, -1); }); });
    elItems.querySelectorAll('[data-qty-remove]').forEach(function(b){ b.addEventListener('click', function(){ setQty(b.dataset.key, 0); }); });
    if(focus) restoreFocus(focus);
  }

  function restoreFocus(focus){
    var target = null;
    var rows = Array.prototype.slice.call(elItems.querySelectorAll('.drawer-item'));
    var same = focus.id && rows.filter(function(row){
      var line = lineFor(row.dataset.key);
      return line && window.BTCart.identity(line) === focus.id;
    })[0];
    if(same && focus.role) target = same.querySelector(ROLES[focus.role]);
    if(!target && rows.length){
      var near = rows[Math.min(Math.max(focus.index, 0), rows.length - 1)];
      target = near.querySelector(ROLES[focus.role] || ROLES.remove) || near.querySelector(ROLES.remove);
    }
    if(!target) target = elItems.querySelector('.cart-empty a') || panel;
    if(target) target.focus({ preventScroll: true });
  }

  /*
    The drawer keeps the quantity the shopper is AIMING for, per line
    identity, as { quantity, rev }: + and - move it, Remove sets it to 0.
    Each click used to read the last confirmed cart, so two quick + clicks
    from 1 both asked for 2 (Codex, second pass); and Remove sent the key it
    was clicked on, which a change ahead of it in the queue could re-key
    (third pass). Now one change at a time goes out per line, carrying the
    newest target to the key the line has when its turn comes; it clears the
    target only if no newer one was set while it was out, and otherwise the
    newer one follows it. The row shows the target until the cart answers,
    and the confirmed quantity after, success or failure.
  */
  var aim = {};      // identity -> { quantity, rev }
  var aimRev = 0;
  var sending = {};  // identity -> a change is on its way

  function lineFor(key){
    return lastCart && lastCart.items.filter(function(i){ return i.key === key; })[0];
  }
  function shownQty(item){
    var a = aim[window.BTCart.identity(item)];
    return a ? a.quantity : item.quantity;
  }
  function setAim(key, quantity){
    var line = lineFor(key);
    if(!line) return;
    var id = window.BTCart.identity(line);
    aim[id] = { quantity: Math.max(0, quantity), rev: ++aimRev };
    var row = elItems.querySelector('.drawer-item[data-key="'+ CSS.escape(key) +'"]');
    var val = row && row.querySelector('.qty__val');
    if(val) val.textContent = aim[id].quantity;
    pump(id);
  }
  function changeQty(key, delta){
    var line = lineFor(key);
    if(!line) return;
    var a = aim[window.BTCart.identity(line)];
    setAim(key, (a ? a.quantity : line.quantity) + delta);
  }
  // Remove is a target of 0, through the same path.
  function setQty(key, qty){ setAim(key, qty); }

  function pump(id){
    if(sending[id]) return;
    sending[id] = true;
    clearCartError();
    var sent = null, why = null;
    window.BTCart.change(function(){
      var a = aim[id];
      if(!a) return null;
      var l = window.BTCart.lookup(id);
      if(l.state !== 'ok'){ why = l.state; return null; }
      sent = a;
      return { id:l.key, quantity:a.quantity };
    }).then(function(){ settle(id, sent, why, null); }, function(err){ settle(id, sent, why, err); });
  }

  function settle(id, sent, why, err){
    sending[id] = false;
    var a = aim[id];
    if(why){
      delete aim[id];
      showCartError(window.BT_T('cart_line_changed', 'That piece changed in your bag while you were editing it. Please check its quantity.'));
      if(why !== 'absent') refresh().catch(function(){});
    } else if(a && sent && a.rev !== sent.rev){
      // A newer target was set while this one was out. If the cart already
      // holds it there is nothing to send; otherwise it goes now.
      var line = lastCart && lastCart.items.filter(function(i){ return window.BTCart.identity(i) === id; })[0];
      if(line && line.quantity === a.quantity) delete aim[id];
      else { pump(id); return; }
    } else {
      delete aim[id];
    }
    // Show what the cart confirmed. Unchanged rows are not replaced.
    if(lastCart) render(lastCart);
    if(err) showCartError((err && err.message) ? err.message : 'That quantity is not available.');
  }

  function refresh(){ return window.BTCart.refresh(); }
  window.refreshCartDrawer = refresh;

  document.addEventListener('bt:cart', function(e){
    var map = readTerms(e.detail.sections && e.detail.sections[TERMS_SECTION]);
    if(map){ takeTerms(map); lookupSettled(e.detail.cart); }
    render(e.detail.cart);
    syncNote(e.detail.cart);
    classifyNew(e.detail.cart);
  });
  // An add that succeeded and then could not read the cart back.
  document.addEventListener('bt:cart-stale', function(){
    showCartError(window.BT_T('cart_stale', 'Added to your bag. It could not be shown just now; refresh the page to see it.'));
  });

  // Note / gift message. Debounced so it saves as they stop typing, without a
  // button they might forget to press.
  var elNote = drawer.querySelector('.js--cart-note');
  var elNoteStatus = drawer.querySelector('.js--cart-note-status');
  var noteTimer = null;

  function syncNote(cart){
    // Never clobber what someone is in the middle of writing.
    if(!elNote || document.activeElement === elNote) return;
    var incoming = cart && typeof cart.note === 'string' ? cart.note : '';
    if(elNote.value !== incoming) elNote.value = incoming;
  }

  function saveNote(){
    if(!elNote) return;
    if(elNoteStatus) elNoteStatus.textContent = 'Saving…';
    // Through BTCart's queue, so a note cannot land between a change and the
    // read that confirms it.
    window.BTCart.update({ note: elNote.value })
      .then(function(){ if(elNoteStatus) elNoteStatus.textContent = 'Saved'; })
      .catch(function(){ if(elNoteStatus) elNoteStatus.textContent = "Couldn't save that note."; });
  }

  if(elNote){
    elNote.addEventListener('input', function(){
      if(elNoteStatus) elNoteStatus.textContent = '';
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 700);
    });
    // Catch anyone who types and immediately closes the drawer or checks out.
    elNote.addEventListener('blur', function(){ clearTimeout(noteTimer); saveNote(); });
  }

  // close handled via delegation below

  // open from any cart trigger (event delegation — robust to timing & section re-renders)
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-cart-open]');
    if(trigger){ e.preventDefault(); openDrawer(); }
    var closer = e.target.closest('[data-cart-close]');
    if(closer && drawer.contains(closer)){
      if(closer.tagName !== 'A'){ e.preventDefault(); }
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  // AJAX add-to-cart: intercept product forms, add, then open drawer
  function wireAddToCart(){
    document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]').forEach(function(form){
      if(form.__btCartWired) return; form.__btCartWired = true;
      form.addEventListener('submit', function(e){
        e.preventDefault();
        // One add at a time per form. The button is disabled while an add is
        // out, which stops a second click; this stops a second SUBMIT, which
        // Enter in a field or requestSubmit() can send past a disabled button.
        if(form.__btAdding) return;
        var btn = form.querySelector('#js--addtocart, [type="submit"]');
        var label = btn ? btn.innerHTML : '';
        /* The button's state comes from what the form will post NOW. The
           shopper can pick another size while the add is out, and restoring
           the label and enabled state from before the add put "Add to bag"
           back on a sold-out size, or on a pre-order size that should say
           Pre-order (Codex full-theme review, 2026-11-02, finding 3). The
           product page owns that state (btSyncBuyButton in theme.js); any
           other form gets back what it had. */
        function restore(){
          form.__btAdding = false;
          if(!btn) return;
          btn.classList.remove('is-loading');
          var synced = btn.id === 'js--addtocart' && typeof window.btSyncBuyButton === 'function' && window.btSyncBuyButton();
          if(!synced){ btn.disabled = false; btn.innerHTML = label; }
        }

        // Never post an add without a variant id; Shopify would otherwise pick one for us.
        var idField = form.querySelector('[name="id"]');
        if(!idField || !idField.value){
          showAddError(form, 'Please choose a size.');
          return;
        }

        form.__btAdding = true;
        if(btn){ btn.disabled = true; btn.classList.add('is-loading'); }
        clearCartError();
        // Shopify returns 422 with a description when an item can't be added
        // (sold out, quantity unavailable), and BTCart rejects with it. An add
        // that succeeded resolves even if reading the cart back failed, so the
        // form never reports a failure for a line that is in the bag; the
        // drawer explains instead, through bt:cart-stale.
        window.BTCart.add(new FormData(form))
          .then(function(){
            restore();
            clearAddError(form);
            openDrawer();
          })
          .catch(function(err){
            restore();
            showAddError(form, err && err.message ? err.message : 'This item could not be added.');
            // Unknown, not refused: the add may have happened. BTCart has put
            // the real bag in the drawer; open it rather than invite a retry.
            if(err && err.unknown) openDrawer();
          });
      });
    });
  }

  function showAddError(form, message){
    var box = form.querySelector('.atb__error');
    if(!box){
      box = document.createElement('p');
      box.className = 'atb__error';
      box.setAttribute('role','alert');
      var atb = form.querySelector('.atb');
      if(atb && atb.parentNode) atb.parentNode.insertBefore(box, atb.nextSibling);
      else form.appendChild(box);
    }
    box.textContent = message;
  }

  function clearAddError(form){
    var box = form.querySelector('.atb__error');
    if(box) box.remove();
  }

  // The theme editor re-renders the product section with a new form; it is
  // wired too, so its add still goes through BTCart. wireAddToCart marks each
  // form, so a form already wired is left alone.
  document.addEventListener('shopify:section:load', wireAddToCart);

  // init
  function init(){ refresh().catch(function(){}); wireAddToCart(); }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
